export default {
  getDynamicTrends: (url) => ({
    url: url,
  }),
};
